import { Component, Input, EventEmitter, Output, ViewChild, ElementRef, OnInit } from '@angular/core';
import { MatOptionSelectionChange } from '@angular/material/core';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './app-auto-complete.component.html',
  styleUrls: ['./app-auto-complete.component.scss']
})
export class AppAutoCompleteComponent implements OnInit {

  ngOnInit() {
    this.filteredData = this.data;
    if (this.clearOnSelection == true) {
      setTimeout(() => { this.clearInputText(); }, 2000);
    }
  }

  @ViewChild('inputView', { static: true }) inputView: ElementRef;
  filteredData: AppAutoCompleteModel[] = [];

  @Input() inputText: string = "";
  @Input() data: AppAutoCompleteModel[] = [];
  @Input() title: string = "Selecione";
  @Input() placeholder: string = "";
  @Input() autoFilter: boolean = true;
  @Input() clearOnSelection: boolean = false;
  @Input() minCharsToFilter: number = 0;
  @Input() clickable: boolean = false;
  @Input() htmlElementScroll: HTMLElement;

  @Output() onSelected = new EventEmitter<AppAutoCompleteModel>();
  @Output() onChange = new EventEmitter<AppAutoCompleteModel>();
  @Output() onClick = new EventEmitter<string>();
  @Output() onOpened: EventEmitter<boolean> = new EventEmitter();

  onSelectedEvent(selectionChange: MatOptionSelectionChange, item: AppAutoCompleteModel, inputView): void {
    this.inputView.nativeElement.setAttribute('style', 'color: transparent;' );
    this.inputText="" + item.label
    this.inputView.nativeElement.value =""
    
    if (selectionChange.isUserInput == true) {
      this.clearInputText();
      this.onSelected.emit(item);
      setTimeout(() => {      
        this.inputView.nativeElement.setAttribute('style', 'color: black;' );
        this.inputView.nativeElement.value = "" + item.label;
      }, 20);
      
      setTimeout(() => {      
        this.inputView.nativeElement.setAttribute('style', 'color: black;' );
      }, 100);
      if (this.clearOnSelection == true) {
        setTimeout(() => {
          this.clearInputText();
          if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          } else {
            window.focus();
          }
        }, 400);
      }
      this.inputView.nativeElement.setAttribute('style', 'color: black;' );

      this.closedEvent();
    }
  
  }

  clearInput(){
    this.onSelected.emit({label: "", value: ""});
  }

  clearInputText() {
   this.inputView.nativeElement.value = "";
  }

  changeEvent(value): void {

    if (value.length < this.minCharsToFilter && value.length == 0) {
      this.filteredData = [];
      this.closedEvent();
      return;
    }

    if (value.length >= this.minCharsToFilter) {
      if (this.autoFilter === true) this.filter(value);
    }

    if(value){
      this.closedEvent();
     }
  }
  
  onChangeEvent(value): void {
    if (value.length < this.minCharsToFilter && value.length == 0) {
      this.filteredData = [];
      this.closedEvent();
      return;
    }

    if (value.length >= this.minCharsToFilter) {
      if (this.autoFilter === true) this.filter(value);
      this.inputView.nativeElement.setAttribute('style', 'color: black;' );

    }

    if(value){
      this.onSelected.emit({label: value, value:value});
      this.placeholder=value;
      this.inputText=null;
      this.clearInputText()
      this.filteredData = [];
      this.closedEvent();
     }
  }

  private filter(value: string) {
    if(value.length>0){
    this.filteredData = this.data.filter(option => option.label.toUpperCase().indexOf(value.toUpperCase()) >= 0);
  } else{
    this.filteredData =this.data
  }
  }

  onClickEvent() {
    if (this.clickable === true) {
      this.onClick.emit(this.inputText);
    }
  }

  closedEvent() {
    this.onOpened.emit(true);
    if (this.htmlElementScroll) this.htmlElementScroll.style.overflow = 'auto';
  }

  openEvent() {
    this.onOpened.emit(false);
    if (this.htmlElementScroll) this.htmlElementScroll.style.overflow = 'hidden';
  }

  static getHtmlElement(element: string) {
    return document.querySelector<HTMLElement>(element)!;
  }

}

export interface AppAutoCompleteModel {
  label: string;
  value: any;
}
